export default __webpack_public_path__ + "static/media/copy.0997734d.svg";